import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import ApiService from '@/services/Api'

export function useFetch<Data = any>(url: string, callback: (data: any) => void, options?: SWRConfiguration) {
    const { data, error, isValidating } = useSWR<Data>(url, async url => {
        const { data } = await ApiService.get(url)

        callback(data)

        return data
    }, options)

    return { data, error, isValidating }
}
